import { DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { exhaustMap, fromEvent } from 'rxjs';

import { AuthenticationService } from '@finverity/authentication';

/**
 * Retries the logout of a cookie session that stayed open on the server as soon as the browser is back online, so a
 * sign-out whose call failed while offline does not leave the session alive until the next application start. The
 * service itself decides whether the pending logout is still safe to send; a retry is skipped while another one runs.
 *
 * @param browserWindow - Window whose reconnections are watched.
 * @param authenticationService - Owner of the pending logout.
 * @param destroyRef - Lifetime the subscription is tied to.
 */
export function retryPendingServerLogoutOnReconnect(
  browserWindow: Window,
  authenticationService: AuthenticationService,
  destroyRef: DestroyRef
): void {
  fromEvent(browserWindow, 'online')
    .pipe(
      exhaustMap(() => authenticationService.endOrphanedCookieSession()),
      takeUntilDestroyed(destroyRef)
    )
    .subscribe();
}
